
export const BASEURLS = (path) => {
    return `https://satkartar.one/assets/center/${path}`;
}
export const BASEMISURLS = (path) => {
    return `https://satkartar.one/assets/mis/${path}`;
}
export const BASEAGENTURLS = (path) => {
    return `https://satkartar.one/assets/agent/${path}`;
}